export const sx = {
    item: {
        transition: 'all .3s',
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        padding: "0px",
        margin: "0px 2px",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid transparent',
        '.lightTheme &': {
            color: 'rgba(0, 0, 0, 0.4)',
        },
        '.lightTheme &.currentMoth': {
            color: "rgba(0, 0, 0, 0.87)",
        },
        '&.currentDay': {
            border: '1px solid rgba(0, 0, 0, 0.6)',
        },
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: 'rgba(25, 118, 210, 0.04)',
        },
        '&.active': {
            color: 'rgb(255, 255, 255)',
            backgroundColor: 'rgb(25, 118, 210)'
        },
    }
}